<template>
    <div class="main">
        <div class="block">
            <RegisterBeneficiaryForEvent :id="this.id"></RegisterBeneficiaryForEvent>
        </div>
        <RegistrationList :id="this.id"></RegistrationList>
    </div>
</template>

<script>
import RegisterBeneficiaryForEvent from '../../components/events/RegisterBeneficiaryForEvent.vue';
import RegistrationList from '../../components/events/RegistrationList.vue';

export default {
    props: {
        id: {
            type: String,
            required: true
        }
    },
    components: {
        RegisterBeneficiaryForEvent,
        RegistrationList
    }
}
</script>